import React from 'react';
import { COLORS, FONTS } from './signupStyles';

export const StepIndicator = ({ currentStep, totalSteps = 4, stepLabels }) => (
  <div style={{ marginBottom: '28px' }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center', marginBottom: '8px' }}>
      {Array.from({ length: totalSteps }, (_, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            maxWidth: '48px',
            height: '4px',
            borderRadius: '2px',
            backgroundColor: i <= currentStep ? COLORS.text : COLORS.border,
            transition: 'all 0.3s ease'
          }}
        />
      ))}
    </div>
    <div style={{
      textAlign: 'center',
      fontSize: '13px',
      fontWeight: '500',
      color: COLORS.muted,
      fontFamily: FONTS.system
    }}>
      {stepLabels
        ? stepLabels[currentStep]
        : `Step ${currentStep + 1} of ${totalSteps}`}
    </div>
  </div>
);
